
import { defineComponent } from 'vue'

// import styled component
import StyledResetPassword from '@/styled-components/pages/reset-password'

export default defineComponent({
  name: 'ChangePassword',
  components: {
    StyledResetPassword
  },
  setup() {}
})
